export const NAVITEMS = [
    'Products',
    'Services',
    'Industries',
    'Shop',
    'Company Info',
]
